<template>
<div class="apCodeUpload-page-content winner-page__hero">
   <div class="main-block position-relative">
      <div class="container-xl pt-lg-5 mt-5">
        <div class="row">
            <div class="col-12">
                <div class="winner-bg">
                    <div class="row">   
                        <div class="col-12 col-lg-5 position-relative winner-page__winning order-1 order-lg-0">
                            <img v-if="winnerType == 'daily'" src="@/assets/imgs/winnings-napi.png" alt="napi nyememény" width="80%" class="img-fluid mb-2"/>
                            <img v-if="winnerType == 'weekly'" src="@/assets/imgs/winnings-weekly.png" alt="heti nyeremény" width="80%" class="img-fluid"/>
                            <img v-if="winnerType == 'hourly'" src="@/assets/imgs/winnings-hour.png" class="img-fluid me-3" width="80%">                            
                        </div>
                        <div class="col-12 col-lg-5 offset-lg-2 d-md-flex justify-content-center flex-column order-0 order-lg-1">
                            <div class="text-center">
                                <h1 class="text-primary text-uppercase fw-900 mb-3" style="border-radius:5px;">
                                    <img src="@/assets/imgs/winnings-heading.png" alt="nyememény" class="img-fluid mb-2" width="80%"/>
                                </h1>  
                                <p class="fs-30 text-white font-primary text-uppercase">Érvényes pályázat esetén megnyerted</p>            
                                <p class="text-white px-2 pb-1 pt-2 mb-0 fs-32 winner-page__hero__winning mb-3">
                                    <span v-if="winnerType == 'daily'"><span class="">napi nyereményünket</span></span>
                                    <span v-if="winnerType == 'weekly'"><span class="">heti nyereményünket</span></span>
                                    <span v-if="winnerType == 'hourly'"><span class="">óránkénti nyereményünket</span></span>
                                </p>
                                <p class="font-primary text-white text-uppercase" style="font-size:18px;line-height:22px;">Görgess lejjebb és add meg a nyeremény átvételéhez szükséges adatokat. <br>A részletekkel kapcsolatban e-mailben fogunk keresni téged.</p>
                            </div>
                        </div>   
                    </div>
                </div>
            </div>
        </div>   
    </div>    
  </div>
  <div class="py-3 bg-dark-red text-center text-white">                               
        <p class="mb-0 font-primary fs-22 px-3" style="line-height:25px;">Részletek a <a class="text-whtie text-underline" :href="$store.state.file_url" target="_blank">Játékszabályzatban</a>.<br>Óránkénti nyeremény: naponta összesen 15 db, 07:00:00 és 21:59:59 között.<br/>A nyitófelület vagy kupakot a nyereményjáték lezárulta után további 2 hónapig (2024.szeptember 15-ig.),<br>illetve a nyertesség esetén a nyeremények átadásáig meg kell őrizni.</p>
    </div> 
</div>
</template>

<script>

export default {
    components:{
        //Ribbon
    },
    props:['winnerType']
}
</script>